import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";

let initialized = false;

export function initBugsnag() {
    if (initialized || typeof window === "undefined") return;

    const apiKey = process.env.NEXT_PUBLIC_BUGSNAG_API_KEY;
    if (!apiKey) {
        console.warn("[Bugsnag] API key not configured");
        return;
    }

    const env = process.env.NEXT_PUBLIC_ENV;
    let releaseStage = "localhost";
    if (env === "production") releaseStage = "production";
    else if (env === "development") releaseStage = "development";

    Bugsnag.start({
        apiKey,
        plugins: [new BugsnagPluginReact()],
        releaseStage,
        enabledReleaseStages: ["production", "development", "localhost"],
        appVersion: process.env.NEXT_PUBLIC_APP_VERSION || "1.0.0",
    });

    initialized = true;
}

export function setBugsnagUser(user: { id: string; email: string; name?: string }) {
    if (!initialized) return;
    Bugsnag.setUser(user.id, user.email, user.name);
}

export function notifyError(error: Error, metadata?: Record<string, unknown>) {
    if (!initialized) {
        console.error("[Bugsnag] Not initialized:", error);
        return;
    }
    Bugsnag.notify(error, (event) => {
        if (metadata) {
            event.addMetadata("custom", metadata);
        }
    });
}

export { Bugsnag };
